import { BiCheck } from "react-icons/bi";

const SuccessIcon = () => (
  <div style={{ position: "relative", width: 120, height: 120, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 24 }}>
    <div style={{ position: "absolute", width: 120, height: 120, borderRadius: "50%", background: "rgba(230,100,60,0.08)" }} />
    <div style={{ position: "absolute", width: 90, height: 90, borderRadius: "50%", background: "rgba(230,100,60,0.14)" }} />
    <div style={{ width: 60, height: 60, borderRadius: "50%", background: "#e6643c", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <BiCheck size={32} color="white" />
    </div>
  </div>
);

export default SuccessIcon;
